
import Item from "components/Elements/Item";
import ItemLookup from "components/Elements/ItemLookup";
import LayawayItems from "components/Elements/LayawayItems";
import WorkOrderItems from "components/Elements/WorkOrderItems";
import Product from "components/Elements/Product";
import ProductLookup from "components/Elements/ProductLookup";
import ReportFilterToggles from "components/Elements/ReportFilterToggles";
import ScannableCard from "components/Elements/ScannableCard";
import MembershipBillingAlert from "components/Elements/MembershipBillingAlert";


const Elements = {
	Item:Item,
	ItemLookup: ItemLookup,
	LayawayItems: LayawayItems,
	WorkOrderItems: WorkOrderItems,
	Product:Product,
	ProductLookup:ProductLookup,
	ReportFilterToggles: ReportFilterToggles,
	ScannableCard: ScannableCard,
	MembershipBillingAlert: MembershipBillingAlert,

};

export default Elements;
